/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PublishCgvNewVersionDto { 
    /**
     * id of cgv
     */
    cgvId?: string;
    /**
     * Content of legal
     */
    content?: string;
    /**
     * Content of legal in English
     */
    contentEn?: string;
    /**
     * Content of legal in French
     */
    contentFr?: string;
    /**
     * Published date of legal
     */
    publishedDate?: string;
    /**
     * Who published the legal
     */
    publishedById?: string;
}

